import axios from "axios";
import { SERVER_URL } from "../config";


export const loginUser = async (email, password) => {
  try {
    const response = await axios.post(
      `${SERVER_URL}/login.php`,
      {
        email,
        password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Login API Error:", error);

    return {
      status: "error",
      message:
        error.response?.data?.message ||
        "Unable to connect to server. Please try again.",
    };
  }
};
